/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 9.7
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

/**
 * GlobalSearchApi - API service
 * @generated from OpenAPI specification
 */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalSearchResult } from '../model/global-search-result';

@Injectable({ providedIn: 'root' })
export class GlobalSearchApi {
    private readonly http = inject(HttpClient);
    private readonly basePath = '';

    /**
     * Perform a unified semantic search across entity types
     * Searches across multiple entity types (exercises, lectures, lecture units, exams, FAQs, channels, courses, posts, answer posts) with a consistent response format. When courseId is not specified, the search is performed globally across all courses the authenticated user has access to. Per-type access rules are enforced server-side via compound Weaviate filters.
     * @param q Search query; can be empty to retrieve recent items
     * @param types Comma-separated entity type filter (exercise, lecture, lecture_unit, exam, faq, channel, course, post, answer_post) or \&#39;all\&#39;; default \&#39;all\&#39;
     * @param courseId Course ID to restrict the search to a single course
     * @param limit Maximum number of results (1–25, default 10)
     */
    globalSearch(q: string, types?: string, courseId?: number, limit?: number): Observable<Array<GlobalSearchResult>> {
        const queryParams = new URLSearchParams();
        if (q !== undefined && q !== null) {
            queryParams.set('q', String(q));
        }
        if (types !== undefined && types !== null) {
            queryParams.set('types', String(types));
        }
        if (courseId !== undefined && courseId !== null) {
            queryParams.set('courseId', String(courseId));
        }
        if (limit !== undefined && limit !== null) {
            queryParams.set('limit', String(limit));
        }
        const queryString = queryParams.toString();
        const url = `${this.basePath}/api/search${queryString ? `?${queryString}` : ''}`;
        return this.http.get<Array<GlobalSearchResult>>(url);
    }

}
